window.oxgStoredIDs = new Array

export function oxgIdIsUnique(id, array = oxgStoredIDs) {
    if (typeof id !== 'string') {
        throw new Error('ID must be an integer');
    }
    return !array.includes(id);
}

export function oxgGenerateUniqueId(length = 16) {
    let id;
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let unique = false;
    let counter = 0;
    while (unique == false && counter < 999) {
        id = '';
        for (let i = 0; i < length; i++) {
            id += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        unique = oxgIdIsUnique(id);
        counter++;
    }
    if(unique) {
        oxgStoredIDs.push(id);
        return id;
    } else {
        throw new Error('Unable to generate a unique ID after 999 attempts.');
    }
}